/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SpreadsheetNote } from '../models/SpreadsheetNote';
import type { SpreadsheetNoteGet } from '../models/SpreadsheetNoteGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpreadsheetNotesService {
  /**
   * Concrete view for bulk saving spreadsheet note instances.
   * @param pageType
   * @param capTable
   * @param fundOwnership
   * @param financialStatement
   * @param fundMeasurementDate
   * @param allocation
   * @param valuationApproach
   * @param valuationApproachValuation
   * @param companyMeasurementDate
   * @param marketAdjustment
   * @param fundInvestmentOwnership
   * @returns SpreadsheetNote
   * @throws ApiError
   */
  public static apiSpreadsheetNotesList(
    pageType?: string,
    capTable?: string,
    fundOwnership?: string,
    financialStatement?: string,
    fundMeasurementDate?: string,
    allocation?: string,
    valuationApproach?: string,
    valuationApproachValuation?: string,
    companyMeasurementDate?: string,
    marketAdjustment?: string,
    fundInvestmentOwnership?: string
  ): CancelablePromise<Array<SpreadsheetNote>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/spreadsheet-notes/',
      query: {
        page_type: pageType,
        cap_table: capTable,
        fund_ownership: fundOwnership,
        financial_statement: financialStatement,
        fund_measurement_date: fundMeasurementDate,
        allocation: allocation,
        valuation_approach: valuationApproach,
        valuation_approach__valuation: valuationApproachValuation,
        company_measurement_date: companyMeasurementDate,
        market_adjustment: marketAdjustment,
        fund_investment_ownership: fundInvestmentOwnership,
      },
    });
  }
  /**
   * Concrete view for bulk saving spreadsheet note instances.
   * @param data
   * @returns SpreadsheetNoteGet
   * @throws ApiError
   */
  public static apiSpreadsheetNotesCreate(data: Array<SpreadsheetNote>): CancelablePromise<Array<SpreadsheetNoteGet>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/spreadsheet-notes/',
      body: data,
    });
  }
  /**
   * Concrete view for retrieving SpreadsheetNote instances.
   * @param id A unique integer value identifying this spreadsheet note.
   * @returns SpreadsheetNoteGet
   * @throws ApiError
   */
  public static apiSpreadsheetNotesRead(id: number): CancelablePromise<SpreadsheetNoteGet> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/spreadsheet-notes/{id}',
      path: {
        id: id,
      },
    });
  }
}
